var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import templateStr from 'text!./templates/loss-location.html';
import _ from 'underscore';

var fn = function fn(defaultLocaleDetails, LocaleService, GeoCodeService, $interval) {
    return {
        restrict: 'A',
        scope: {
            lossLocationType: '=',
            lossLocation: '=',
            optionalLossLocation: '=?',
            predefinedLossLocations: '=?'
        },
        template: templateStr,
        controller: ['$scope', function ($scope) {
            $scope.addressVerificationVm = {
                value: '',
                aspects: {
                    required: false,
                    get valid() {
                        return $scope.lossLocation.aspects.subtreeValid;
                    }
                }
            };

            $scope.enableMap = true;
            $scope.zoom = 8;
            $scope.newMapCenter = {
                longitude: $scope.lossLocation.center ? $scope.lossLocation.center.longitude : null,
                latitude: $scope.lossLocation.center ? $scope.lossLocation.center.latitude : null
            };
        }],
        link: function link(scope) {
            scope.hasPredefinedLossLocations = function () {
                return scope.predefinedLossLocations && scope.predefinedLossLocations.length > 0;
            };

            scope.$watch('lossLocationType', function (newValue, oldValue) {
                scope.lossLocation.value = scope.lossLocation.value || {};

                if ((newValue === 'predef_address' || oldValue === 'predef_address') && newValue !== oldValue) {
                    // We already have visited opposed option
                    var recovery = _.clone(scope.optionalLossLocation);
                    scope.optionalLossLocation = scope.lossLocation.value;
                    scope.lossLocation.value = recovery;
                }

                if (newValue === 'predef_address' && scope.predefinedLossLocations.length === 1) {
                    scope.lossLocation.value = scope.predefinedLossLocations[0];
                }
            }, true);

            /* If this is set prior to creating a draft claim in ClaimCenter, the presence of the empty object causes validation errors.
             The following lets us use State in 'just know the city'.*/
            if (!scope.lossLocationType) {
                if (!scope.lossLocation.state || !scope.lossLocation.state.value) {
                    // New claim, set loss location type to the default one
                    scope.lossLocationType = scope.hasPredefinedLossLocations() ? 'predef_address' : 'exact_address';
                } else if (scope.hasPredefinedLossLocations() && _.find(scope.predefinedLossLocations, function (lossLocation) {
                    return _.isEqual(lossLocation, scope.lossLocation.value);
                })) {
                    scope.lossLocationType = 'predef_address';
                } else {
                    scope.lossLocationType = scope.lossLocation.addressLine1 ? 'exact_address' : 'city_only';
                }
            }

            scope.addressSelectionFormatter = function (entry) {
                var address = [entry.addressLine1, entry.addressLine2, entry.addressLine3, entry.city, entry.postalCode, entry.state];
                return _.values(address).filter(function (value) {
                    return !!value;
                }).join(', ');
            };

            scope.hideFields = ['AddressLine1', 'AddressLine2', 'AddressLine3', 'PostalCode']; // For 'I just know the city'

            scope.onPositionChange = function (newCenter) {
                if (newCenter && newCenter.lng && newCenter.lat) {
                    GeoCodeService.getGeoCodedAddr(newCenter.lat, newCenter.lng).then(function (address) {
                        address.country = address.countryCode;
                        scope.lossLocation.value = address;
                        scope.lossLocation.center = {
                            latitude: newCenter.lat,
                            longitude: newCenter.lng
                        };
                    });
                }
            };

            /**
             * scope.isMapsLoaded
             * Checks if the google maps API has been loaded
             *
             * @returns {true} if maps has been successfully loaded, {false} otherwise.
             */
            scope.isMapsLoaded = false;

            var interval = $interval(function () {
                // waiting until GOOGLE MAPS are loaded
                if (_typeof(window.google) === 'object' && _typeof(window.google.maps) === 'object') {
                    scope.isMapsLoaded = true;
                    $interval.cancel(interval);
                }
            }, 100);
        }
    };
};

fn.$inject = ['defaultLocaleDetails', 'LocaleService', 'GeoCodeService', '$interval'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/common/directives/LossLocation.js
// module id = 1522
// module chunks = 0